// src/Apis/apiCall.js
import axios from "axios";

const BASE_URL = "https://pevbackend.codovio.com/public/api";

export const apiCall = async (
  method,
  endpoint,
  data = null,
  navigate = null,
  isFormData = false
) => {
  const token = localStorage.getItem("access_token");
  const expiryTime = localStorage.getItem("token_expiry");
  const currentTime = Date.now();

  // Handle token expiration or absence
  if (!token || !expiryTime || currentTime > Number(expiryTime)) {
    localStorage.clear();
    if (navigate) {
      navigate("/sign-in", { replace: true });
    } else {
      window.location.href = "/sign-in";
    }
    return;
  }

  try {
    const config = {
      method: method.toLowerCase(),
      url: `${BASE_URL}${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

   if (["post", "put", "patch", "delete"].includes(method.toLowerCase()) && data) {
  config.data = data;
}

    if (method.toLowerCase() === "get" && data) {
      config.params = data;
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      if (navigate) {
        navigate("/sign-in", { replace: true });
      } else {
        window.location.href = "/sign-in";
      }
      return;
    }
    throw error;
  }
};
